document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.aimma-hero-carousel').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('.aimma-hero-carousel__slide');
    var dots = carousel.querySelectorAll('.aimma-hero-carousel__dot');

    if (slides.length <= 1) return;

    var current = 0;
    var intervalMs = parseInt(carousel.getAttribute('data-autoplay'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      timer = setInterval(function () {
        goTo(current + 1);
      }, intervalMs);
    }

    function restartAutoplay() {
      if (timer) clearInterval(timer);
      startAutoplay();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        restartAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', function () {
      if (timer) clearInterval(timer);
    });

    carousel.addEventListener('mouseleave', function () {
      restartAutoplay();
    });

    startAutoplay();
  });
});
